"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _utilities = require("../../utilities");
var _switchModule = _interopRequireDefault(require("./switch.module.scss"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var Switch = function Switch(props) {
  var className = "switch";
  if (props.disabled) {
    className = "switchDisabled";
  }
  return /*#__PURE__*/_react["default"].createElement("label", {
    className: _switchModule["default"][className]
  }, /*#__PURE__*/_react["default"].createElement("input", _extends({
    type: "checkbox",
    "data-testid": "switch-checkbox",
    checked: props.checked,
    disabled: props.disabled && "disabled",
    onChange: function onChange(e) {
      if (!props.disabled && props.onChange) {
        props.onChange(e);
      }
    }
  }, _utilities.utilities.getDataAttributes(props))), /*#__PURE__*/_react["default"].createElement("div", {
    className: _switchModule["default"].slider
  }, " "));
};
Switch.propTypes = {
  disabled: _propTypes["default"].bool,
  onChange: _propTypes["default"].func
};
var _default = exports["default"] = Switch;